import { ESS_BASE_URL } from '../../../utils/app-host';
import { Menu } from '../models/menu.model';

export enum EssMenuItemsEnum {
	PersonalData = 10,
	Communication = 20,
	PermanentResidence = 30,
	MailingAddress = 40,
	EmergencyContact = 50,
	MessageCenter = 60,
}

/* ESS side menu (titles are translation keys), as in ess-location-dashboard. Router links are under /ess, or at the root on the ESS hostname. */
export const essMenuItems: Menu[] = [
	new Menu(
		EssMenuItemsEnum.PersonalData,
		'ess.personal-data.title',
		ESS_BASE_URL + '/personal-data',
		null,
		'assignment_ind',
		null,
		null,
		false,
		0
	),
	new Menu(
		EssMenuItemsEnum.Communication,
		'ess.communication.communication',
		ESS_BASE_URL + '/communication',
		null,
		'alternate_email',
		null,
		null,
		false,
		0
	),
	new Menu(
		EssMenuItemsEnum.PermanentResidence,
		'ess.address.permanent-residence',
		ESS_BASE_URL + '/permanent-residence',
		null,
		'location_on',
		null,
		null,
		false,
		0
	),
	new Menu(
		EssMenuItemsEnum.MailingAddress,
		'ess.address.mailing-address',
		ESS_BASE_URL + '/mailing-address',
		null,
		'contact_mail',
		null,
		null,
		false,
		0
	),
	new Menu(
		EssMenuItemsEnum.EmergencyContact,
		'ess.emergency-contact.emergency-contact',
		ESS_BASE_URL + '/emergency-contact',
		null,
		'contacts',
		null,
		null,
		false,
		0
	),
];

/** Only added to the menu for message center admins (MessageCenter_* AD groups) */
export const messageCenterMenuItem = new Menu(
	EssMenuItemsEnum.MessageCenter,
	'ess.message-center.title',
	ESS_BASE_URL + '/message-center',
	null,
	'campaign',
	null,
	null,
	false,
	0
);
